module.exports = __webpack_public_path__ + "d05caa993a6c168238787f78a646a8f9.jpg";